import { type ProcessDoc } from '../rxdb/collections/processes';
import { useDatabase } from '../rxdb/provider';
import { useEffect, useState } from 'react';

type ProcessState = {
  process: null | ProcessDoc;
  processId: string;
};

export const useProcess = (processId?: null | string) => {
  const { db } = useDatabase();
  const [state, setState] = useState<null | ProcessState>(null);

  useEffect(() => {
    if (!processId) {
      return undefined;
    }

    const sub = db.processes.findOne(processId).$.subscribe((doc) => {
      setState({ process: doc?.toJSON() ?? null, processId });
    });

    return () => sub.unsubscribe();
  }, [db, processId]);

  const hasCurrentState = Boolean(processId && state?.processId === processId);

  return {
    isLoading: Boolean(processId) && !hasCurrentState,
    process: hasCurrentState ? (state?.process ?? null) : null,
  };
};
